import { createReducer, on } from '@ngrx/store';
import { ClickActions } from './click.actions';
import { Command, Device, Template } from '../../../shared/interfaces/click.interfaces';

export const clickFeatureKey = 'click';

export interface ClickState {
  foundDevice?: Device | undefined;
  commands?: Command[] | undefined;
  selectedCommand?: Command | undefined;
  templates?: Template[] | undefined;
  selectedTemplate?: Template | undefined;
}

export const initialState: ClickState = {
};

export const clickReducer = createReducer(
  initialState,

  on(ClickActions.searchDeviceSuccess, (state, action) => { return { ...state, foundDevice: action.data } }),

  on(ClickActions.loadCommandsSuccess, (state, action) => { return { ...state, commands: action.data } }),

  on(ClickActions.loadCommandByIdSuccess, (state, action) => { return { ...state, selectedCommand: action.data } }),
  on(ClickActions.unsetSelectedCommand, (state) => { return { ...state, selectedCommand: undefined } }),

  on(ClickActions.loadTemplatesSuccess, (state, action) => { return { ...state, templates: action.data } }),

  on(ClickActions.loadTemplateByIdSuccess, (state, action) => { return { ...state, selectedTemplate: action.data } }),
  // on(ClickActions.addCommandSuccess, (state, action) => { return { ...state, selectedTemplate: action.data } }),
  // on(ClickActions.removeCommandSuccess, (state, action) => { return { ...state, selectedTemplate: action.data } }),
  // on(ClickActions.addNotificationSuccess, (state, action) => { return { ...state, selectedTemplate: action.data } }),
  // on(ClickActions.removeNotificationSuccess, (state, action) => { return { ...state, selectedTemplate: action.data } }),
  on(ClickActions.unsetSelectedTemplate, (state) => { return { ...state, selectedTemplate: undefined } }),

  on(ClickActions.unsetClickStore, () => initialState),
  
  on(ClickActions.addCommandSuccess, (state, action) => { 
    return { 
      ...state, 
      selectedTemplate: action.data,
      // También actualizar la lista de templates si es necesario
      templates: state.templates?.map(t => t.id === action.data.id ? action.data : t)
    } 
  }),

  on(ClickActions.removeCommandSuccess, (state, action) => { 
    return { 
      ...state, 
      selectedTemplate: action.data,
      templates: state.templates?.map(t => t.id === action.data.id ? action.data : t)
    } 
  }),

  on(ClickActions.addNotificationSuccess, (state, action) => { 
    return { 
      ...state, 
      selectedTemplate: action.data,
      templates: state.templates?.map(t => t.id === action.data.id ? action.data : t)
    } 
  }),

  on(ClickActions.removeNotificationSuccess, (state, action) => { 
    return { 
      ...state, 
      selectedTemplate: action.data,
      templates: state.templates?.map(t => t.id === action.data.id ? action.data : t)
    } 
  }),
  

);
